async function send(message = '', options = {}) {
    if(!message) throw Error('No message provided')
    
    const { botname, Interactions } = options
    
    if(!botname) throw Error('No botname provided')
    if(!Interactions) throw Error('No Interactions provided')

    try {
        
        return await Interactions.send(botname, message)
    } catch (error) {
        throw error
    }
}

const MessageService = (options = {}) => ({
    send: (input = '', sendOptions = {}) => send(input, { 
        botname: options.botname,
        Interactions: options.Interactions,
        ...sendOptions
    })
})

export default MessageService